(
    function (global, $, jcf, Si) {
        "use strict";

        Si.when('Ajax/Upg', 'Templates', 'Helpers', 'TableSorter').then(upgPage);

        //@todo resolve 404 with restoring previous controls values
        function upgPage(Upg, Templates, Helpers, TableSorter) {

            var VIEW_TYPE_TOTALS = 'totals',
                VIEW_TYPE_MATCHES_STATS = 'matches-stats',
                VIEW_TYPE_MATCHES_PLAYERS = 'matches-players';
            var controls = {},
                //cache = {},
                changeHandlers = {
                    "country": countryChangeHandler,
                    "team": teamChangeHandler,
                    "tournament": tournamentChangeHandler,
                    "season": seasonChangeHandler,
                    "matchesTotals": matchesTotalsChangeHandler,
                    "playersStats": playersStatsChangeHandler,
                    "display": displayChangeHandler
                },
                $viewsHolder = $('[data-view]'),
                $loader = $('[data-loader]');

            initControls();
            initSynchronousHovering();
            $(document).on('click','.link-embedded',function(){
                $(this).click(function(e){
                    e.stopPropagation();
                    return true;
                });
            });

            function initControls() {

                jcf.setOptions(
                    'Select', {
                        wrapNative: false,
                        wrapNativeOnMobile: true
                    }
                );
                jcf.replaceAll();

                controls[ 'all' ] = $('[data-control]');

                controls[ 'all' ].each(
                    function () {
                        var $ctrl = $(this),
                            name = $ctrl.data('control');
                        controls[ $ctrl.data('control') ] = $ctrl;
                        if ($ctrl.is('select')) {
                            $ctrl.data('lastValue', $ctrl.val());
                            $ctrl.on('change', getSelectChangeHandler(name));
                        } else {
                            $ctrl.on('change', changeHandlers[ name ]);
                        }
                    }
                );
                TableSorter.forTable($viewsHolder.find('.tournament-matches'));
            }

            function countryChangeHandler(event) {

                loadData('country');
            }

            function teamChangeHandler(event) {

                loadData('team');
            }

            function tournamentChangeHandler(event) {

                loadData('tournament');
            }

            function seasonChangeHandler(event) {

                loadData('season');
            }

            function matchesTotalsChangeHandler(event) {

                switchPlayersStatsControlState(!$(this).prop("checked"));
                switchDisplayControlState();
                loadData('matchesTotals');
            }

            function playersStatsChangeHandler(event) {

                if (controls.matchesTotals.prop("checked")) {

                    return event.preventDefault();
                }
                switchDisplayControlState();
                loadData('playersStats');
            }

            function displayChangeHandler(event) {

                if (getViewType() != VIEW_TYPE_MATCHES_PLAYERS) {

                    return event.preventDefault();
                }

                changeIconsVisibility();
            }

            function getSelectChangeHandler(name) {

                return function (event) {
                    // check if value really changed
                    var $ctrl = $(this),
                        newVal = $ctrl.val(),
                        lastVal = $ctrl.data('lastValue');
                    if (newVal != lastVal) {
                        $ctrl.data('lastValue', newVal);
                        return changeHandlers[ name ].call(this, event);
                    }
                };
            }

            function switchPlayersStatsControlState(state) {

                controls.playersStats.prop("disabled", !state);
                switchCheckboxMuteStyle(controls.playersStats, !state);
            }

            function switchDisplayControlState() {

                var state = getViewType() == VIEW_TYPE_MATCHES_PLAYERS;

                controls.display.prop("disabled", !state);
                switchSelectMuteStyle(controls.display, !state);
            }

            function switchCheckboxMuteStyle($element, mute) {

                switchMuteStyle($element.closest('.form-switcher'), mute);
            }

            function switchSelectMuteStyle($element, mute) {

                switchMuteStyle(getJcfElement($element), mute);
            }

            function switchMuteStyle($element, mute) {

                $element[ (
                    mute ? 'addClass' : 'removeClass'
                ) ]('text-muted');
            }

            function changeIconsVisibility() {

                var value = controls.display.val(),
                    allI = $viewsHolder.find('.frame table tbody i.action-ico');

                if (!value) {
                    allI.show();
                } else {
                    allI.hide();
                    allI.filter('.ico-' + value).show();
                }
            }

            function getJcfElement(element) {

                return getJcf(element).instance.fakeElement;
            }

            function getJcf(element) {

                return jcf.getInstance(element);
            }

            function getViewType() {

                var matchesTotals = controls.matchesTotals.prop("checked"),
                    playersStats = controls.playersStats.prop("checked");
                if (matchesTotals) {

                    return VIEW_TYPE_TOTALS;
                }

                return playersStats ? VIEW_TYPE_MATCHES_STATS : VIEW_TYPE_MATCHES_PLAYERS;
            }

            function loadData(triggerName) {

                var view = getViewType(),
                    params = fillLoadParams(
                        triggerName,
                        {
                            view: view
                        }
                    );
                $loader.addClass('visible');
                return Upg.get(params).then(
                    function (response) {

                        updateControlsFromResponse(response);
                        renderView(view, responseToViewData(response, view));
                    }, function (status, error) {

                        console.log(status, error);
                        alert('Error appear while data loading...');
                        $loader.removeClass('visible');
                    }
                );
            }

            function fillLoadParams(triggerName, params) {
                var return_obj = {
                    view: params.view
                };
                switch (triggerName) {
                    case 'country':
                        //params['return_level'] = "country";
                        return_obj[ 'country' ] = controls.country.val();
                        return_obj['team'] = controls.team.val();
                        break;
                    case 'season':
                        return_obj['team'] = controls.team.val();
                        return_obj['season'] = controls.season.val();
                        return_obj[ 'tournament' ] = controls.tournament.val() || 'all';
                        return_obj[ 'country' ] = controls.country.val();
                        break;
                    case 'playersStats':
                    case 'matchesTotals':
                        return_obj['team'] = controls.team.val();
                        return_obj['season'] = controls.season.val();
                        return_obj[ 'tournament' ] = controls.tournament.val() || 'all';
                        return_obj[ 'country' ] = controls.country.val();
                        break;
                    case 'tournament':
                        return_obj['team'] = controls.team.val();
                        return_obj['season'] = controls.season.val();
                        return_obj[ 'tournament' ] = controls.tournament.val() || 'all';
                        return_obj[ 'country' ] = controls.country.val();
                        break;
                    case 'team':
                        return_obj['team'] = controls.team.val();
                        return_obj['season'] = controls.season.val();
                        return_obj[ 'tournament' ] = controls.tournament.val() || 'all';
                        return_obj[ 'country' ] = controls.country.val();
                        break;
                    default:
                        throw new Error("Unknown control trigger data loading!");
                        break;
                }

                return return_obj;
            }

            function updateControlsFromResponse(response) {

                if (response[ 'teams' ]) {
                    updateSelectOptions(controls.team, response[ 'teams' ], 'teams', true);
                }

                if (response[ 'tournaments' ]) {
                    updateSelectOptions(controls.tournament, response[ 'tournaments' ], 'tournaments', false, response[ 'select_all_tournaments' ]);
                }

                if (response[ 'seasons' ]) {
                    updateSelectOptions(controls.season, response[ 'seasons' ], 'seasons', true);
                }
            }

            function updateSelectOptions($select, items, tplKey, preselectFirst, select_all_option) {

                var len = items.length;
                if (len && preselectFirst) {
                    items[ 0 ][ 'pre_selected' ] = true;
                }
                items.isEmpty = function () {
                    return !len;
                };
                var tplData = {};
                tplData[ tplKey ] = items;
                if(select_all_option){
                    tplData['select_all_tournaments'] = true;
                }
                $select.empty();
                if(tplKey == 'seasons' || tplKey == 'teams'){
                    $select.append(Templates.make('controls/' + tplKey + '-options-no-all.mustache', tplData));
                }else{
                    $select.append(Templates.make('controls/' + tplKey + '-options.mustache', tplData));
                }

                getJcf($select).refresh();
                // to fix problem when after resetting options
                // user choose same option as was before
                // and nothing happened due to curr!=last value check
                $select.data('lastValue', $select.val());
            }

            function renderView(view, data) {
                var content = Templates.make('match/upg/' + view + '.mustache', data);
                $viewsHolder.empty();
                $viewsHolder.append(content);
                TableSorter.forTable($viewsHolder.find('.tournament-matches'));
                if (getViewType() == VIEW_TYPE_MATCHES_PLAYERS) {
                    changeIconsVisibility();
                }
                $loader.removeClass('visible');
            }

            //@todo add different logic for views
            function responseToViewData(response, view) {

                if(view == VIEW_TYPE_MATCHES_PLAYERS){
                    var viewData = {
                            matches: response.matches,
                            players: response.players,
                        },
                        len = viewData.matches.length;
                    viewData.matches.isEmpty = function () {
                        return !len;
                    };
                    for (var i = 0, player; player = viewData.players[ i ]; i++) {
                        player.goalsAmount = player.goals > 1 ? player.goals : 0;
                        player.ownGoalsAmount = player.own_goals > 1 ? player.own_goals : 0;
                        player.yellowCardsAmount = player.yellow_cards > 1 ? player.yellow_cards : 0;
                        player.redCardsAmount = player.red_cards > 1 ? player.red_cards : 0;
                    }
                }else if(view == VIEW_TYPE_MATCHES_STATS){
                    viewData = response;
                }else if(view == VIEW_TYPE_TOTALS){
                    viewData = response;
                }

                return viewData;
            }



            function initSynchronousHovering() {
                var $tables = $('table.sync-hover');
                // listen on tables with tr due to dom rebuilds
                $tables.on('mouseenter', 'tr', getHandler('addClass'))
                    .on('mouseleave', 'tr', getHandler('removeClass'));

                function getHandler(classMethod) {
                    return function (event) {
                        var $table = $(event.delegateTarget),
                            rowIndex = $table.find('tr').index(this);
                        if (rowIndex == -1) {
                            return;
                        }
                        $tables.not($table).each(
                            function () {
                                var $table = $(this);
                                $table.find('tr').eq(rowIndex)[ classMethod ]('hover');
                            }
                        );
                    };
                }
            }
        }
    }
)(window, jQuery, jcf, Si);
